import Vue from 'vue'

export default {
  state: {
    websiteLogo: '',
    favicon: '',
    title: '',
  },
  mutations: {
    setWebsiteLogo (state, payload) {
      state.websiteLogo = payload
    },
    setFavicon (state, payload) {
      state.favicon = payload
    },
    setTitle (state, payload) {
      state.title = payload
    },
  },
  actions: {
    async fetchWebsiteLogo ({ commit, state, ...ret }, payload = {}) {
      try {
        const {
          data: { data: [data] },
        } = await Vue.http.get('/v1/website_configs?key=logo&limit=1&sort=id&order=desc')
        commit('setWebsiteLogo', data?.value)
      } catch (error) {
        console.error(error)
        // 不再抛出错误，使用默认值
        commit('setWebsiteLogo', '')
      }
    },
    async fetchFavicon ({ commit, state, ...ret }, payload = {}) {
      try {
        const {
          data: { data: [data] },
        } = await Vue.http.get('/v1/website_configs?key=favicon&limit=1&sort=id&order=desc')
        commit('setFavicon', data?.value)
      } catch (error) {
        console.error(error)
        // 不再抛出错误，使用默认值
        commit('setFavicon', '')
      }
    },
    async fetchTitle ({ commit, state, ...ret }, payload = {}) {
      try {
        const {
          data: { data: [data] },
        } = await Vue.http.get('/v1/website_configs?key=title&limit=1&sort=id&order=desc')
        commit('setTitle', data?.value)
      } catch (error) {
        console.error(error)
        // 不再抛出错误，使用默认值
        commit('setTitle', '')
      }
    },
  },
}
